function encodeSpecialCharacters(htmlContent: string) {
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }
    if (htmlContent.includes("<=")) {
        htmlContent = htmlContent.replace(/<=/g, "&lt=");
    }
    if (htmlContent.includes("=<")) {
        htmlContent = htmlContent.replace(/=</g, "=&lt");
    }
    if (htmlContent.includes(">=")) {
        htmlContent = htmlContent.replace(/>=/g, "&gt=");
    }
    if (htmlContent.includes("=>")) {
        htmlContent = htmlContent.replace(/=>/g, "=&gt");
    }

    if (htmlContent.includes("<")) {
        htmlContent = replaceLessThanSign(htmlContent);
    }

    if (htmlContent.includes(">")) {
        htmlContent = replaceGreaterThenSign(htmlContent);
    }

    return htmlContent;
}

function replaceLessThanSign(inputString: any) {
    const replacedString = inputString.replace(/<(?![a-zA-Z/])/g, '&lt;');
    return replacedString;
}

function replaceGreaterThenSign(inputString: any) {
    const replacedString = inputString.replace(/<[^>]*>|>/g, (match: any) => {
        if (match === '>') {
            return '&gt;';
        }
        return match;
    });
    return replacedString;
}

function extractBody(htmlContent: string) {
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }
    const bodyStart = htmlContent.indexOf("<body>");
    const bodyEnd = htmlContent.indexOf("</body>");
    return bodyStart >= 0 && bodyEnd >= 0 ? htmlContent.substring(bodyStart + 6, bodyEnd) : htmlContent;
}

function fixTableCellTags(htmlContent: string){
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }
    htmlContent = htmlContent.replace("<td&gt", "<td>");
    return htmlContent;
}

export default function transformContentHtml(htmlContent: string) {    
    const encoded = encodeSpecialCharacters(htmlContent);
    const fixedTableCellTags = fixTableCellTags(encoded);
    return extractBody(fixedTableCellTags)
}
